import { render, staticRenderFns } from "./HospitalsAndRoles.vue?vue&type=template&id=206c3937&"
import script from "./HospitalsAndRoles.vue?vue&type=script&lang=js&"
export * from "./HospitalsAndRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports